import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.data_manager_entry_v1');
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({ standalone: false,
    selector: 'wiz-page-xray-data_manager_entry_v1',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.data_manager_entry_v1/view.scss */
/* src/app/page.xray.data_manager_entry_v1/view.scss: no such file or directory */`],
})
export class PageXrayData_manager_entry_v1Component implements OnInit {
    public redirectFailed = false;

    constructor(@Inject( Router) public router: Router) { }

    public async ngOnInit() {
        try {
            const moved = await this.router.navigateByUrl(
                '/page.xray/training?workspace=dataset',
                { replaceUrl: true }
            );
            this.redirectFailed = !moved;
        } catch {
            this.redirectFailed = true;
        }
    }

    public retry() {
        this.redirectFailed = false;
        return this.router.navigateByUrl(
            '/page.xray/training?workspace=dataset',
            { replaceUrl: true }
        ).then((moved) => {
            this.redirectFailed = !moved;
        }).catch(() => {
            this.redirectFailed = true;
        });
    }
}

export default PageXrayData_manager_entry_v1Component;